export const detectPhoneNumber = text => {
  text = convertPersianNumberToEnglish(text);
  const pattern2 = /(\+98|0)[0-9]{2,}[0-9]{7,}/g;
  const tels = text.match(pattern2) || [];
  tels.forEach(tel => {
    text = text.replace(
      tel,
      `<a style="unicode-bidi: plaintext" href="tel:${tel}">${tel}</a>`
    );
  });
  return text;
};

const convertPersianNumberToEnglish = num => {
  num = num.toString();
  for (let i = 0; i < num.length; i++) {
    const startPoint = num.indexOf(num[i]);
    const endPoint = num[i].length + startPoint;
    let theFirst = num.substring(0, startPoint);
    let theWord = num.substring(startPoint, endPoint);
    const theRest = num.substring(endPoint, num.length + endPoint);
    for (let j = 0; j < persianNumbers.length; j++) {
      if (num[i].toString() === persianNumbers[j].toString()) {
        if (startPoint !== -1) {
          theWord = englishNumbers[j];
          num = theFirst.toString() + theWord.toString() + theRest.toString();
        }
      }
    }
  }
  return num;
};

const persianNumbers = [
  "۰",
  "۱",
  "۲",
  "۳",
  "۴",
  "۵",
  "۶",
  "۷",
  "۸",
  "۹",
  "۰",
  "١",
  "٢",
  "٣",
  "٤",
  "٥",
  "٦",
  "٧",
  "٨",
  "٩"
];
const englishNumbers = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9"
];
